/*
 * Retourportaal — Vloerenmarkt.nl (storefront)
 * Zelfstandige logica: order opzoeken → artikelen kiezen → methode kiezen → indienen.
 * Praat via de Cloudflare-worker met Mastermind (token zit veilig in de worker).
 *
 * De ophaaldata gebruiken dezelfde beschikbare dagen als de bezorgdatums: de
 * PPC-config hieronder is een kopie van assets/delivery-date-picker.js. Houd beide
 * in sync als de bezorgdagen wijzigen.
 */
(function () {
  "use strict";

  var root = document.querySelector("[data-return-portal]");
  if (!root) return;

  var ENDPOINT = (root.getAttribute("data-endpoint") || "").replace(/\/$/, "");
  var stepLookup = root.querySelector('[data-step="lookup"]');
  var stepForm = root.querySelector('[data-step="form"]');
  var stepDone = root.querySelector('[data-step="done"]');
  var body = root.querySelector("[data-portal-body]");
  var doneText = root.querySelector("[data-done-text]");
  var lookupForm = root.querySelector("[data-lookup-form]");
  var lookupMsg = root.querySelector("[data-lookup-msg]");
  var lookupBtn = root.querySelector("[data-lookup-submit]");
  var introEl = root.querySelector(".return-portal__intro");

  // Past de intro-tekst bovenaan aan per stap (leeg = verbergen).
  function setIntro(txt) {
    if (!introEl) return;
    if (txt) { introEl.textContent = txt; introEl.hidden = false; }
    else { introEl.hidden = true; }
  }

  var DAY_SHORT = ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"];
  var MAANDEN = ["januari", "februari", "maart", "april", "mei", "juni", "juli",
    "augustus", "september", "oktober", "november", "december"];

  // ── PPC-config (kopie uit delivery-date-picker.js) ─────────────────────────
  var PPC_NL = [
    { start: 1011, end: 1018, days: [] }, { start: 1790, end: 1797, days: [] },
    { start: 8880, end: 8899, days: [] }, { start: 9160, end: 9166, days: [] },
    { start: 1001, end: 1789, days: ["Ma", "Wo", "Vr"] }, { start: 1800, end: 2254, days: ["Ma", "Wo", "Vr"] },
    { start: 2311, end: 2481, days: ["Ma", "Wo", "Vr"] }, { start: 3440, end: 3455, days: ["Ma", "Wo", "Vr"] },
    { start: 3470, end: 3545, days: ["Ma", "Wo", "Vr"] }, { start: 3551, end: 3907, days: ["Ma", "Wo", "Vr"] },
    { start: 3925, end: 3985, days: ["Ma", "Wo", "Vr"] }, { start: 6710, end: 6718, days: ["Ma", "Wo", "Vr"] },
    { start: 6730, end: 6745, days: ["Ma", "Wo", "Vr"] }, { start: 6877, end: 6877, days: ["Ma", "Wo", "Vr"] },
    { start: 7300, end: 7364, days: ["Ma", "Wo", "Vr"] }, { start: 7384, end: 7397, days: ["Ma", "Wo", "Vr"] },
    { start: 7400, end: 7437, days: ["Ma", "Wo", "Vr"] }, { start: 8000, end: 8294, days: ["Ma", "Wo", "Vr"] },
    { start: 2260, end: 2303, days: ["Ma", "Di", "Do"] }, { start: 2490, end: 2761, days: ["Ma", "Di", "Do"] },
    { start: 2770, end: 2771, days: ["Ma", "Di", "Do"] }, { start: 2800, end: 3439, days: ["Ma", "Di", "Do"] },
    { start: 3460, end: 3467, days: ["Ma", "Di", "Do"] }, { start: 3546, end: 3546, days: ["Ma", "Di", "Do"] },
    { start: 3910, end: 3922, days: ["Ma", "Di", "Do"] }, { start: 3989, end: 4288, days: ["Ma", "Di", "Do"] },
    { start: 4600, end: 5872, days: ["Ma", "Di", "Do"] }, { start: 6500, end: 6709, days: ["Ma", "Di", "Do"] },
    { start: 6720, end: 6721, days: ["Ma", "Di", "Do"] }, { start: 6800, end: 6874, days: ["Ma", "Di", "Do"] },
    { start: 6880, end: 6999, days: ["Ma", "Di", "Do"] }, { start: 7370, end: 7383, days: ["Ma", "Di", "Do"] },
    { start: 7399, end: 7399, days: ["Ma", "Di", "Do"] },
    { start: 4300, end: 4589, days: ["Di", "Do"] }, { start: 5900, end: 6471, days: ["Di", "Do"] },
    { start: 6500, end: 6709, days: ["Di", "Do"] }, { start: 7000, end: 7275, days: ["Di", "Do"] },
    { start: 7440, end: 7696, days: ["Di", "Do"] },
    { start: 7400, end: 7437, days: ["Wo", "Vr"] }, { start: 7439, end: 7439, days: ["Wo", "Vr"] },
    { start: 7700, end: 7991, days: ["Wo", "Vr"] }, { start: 8300, end: 8872, days: ["Wo", "Vr"] },
    { start: 8900, end: 9156, days: ["Wo", "Vr"] }, { start: 9171, end: 9999, days: ["Wo", "Vr"] },
  ];
  var PPC_BE = [
    { start: 47, end: 49, days: [] }, { start: 54, end: 56, days: [] }, { start: 63, end: 69, days: [] },
    { start: 10, end: 12, days: ["Wo", "Vr"] }, { start: 14, end: 19, days: ["Wo", "Vr"] },
    { start: 77, end: 99, days: ["Wo", "Vr"] },
    { start: 13, end: 13, days: ["Di", "Do"] }, { start: 20, end: 39, days: ["Di", "Do"] },
    { start: 42, end: 44, days: ["Di", "Do"] }, { start: 46, end: 46, days: ["Di", "Do"] },
    { start: 72, end: 72, days: ["Ma"] }, { start: 74, end: 74, days: ["Ma"] },
    { start: 40, end: 41, days: ["Do"] }, { start: 45, end: 45, days: ["Do"] }, { start: 50, end: 53, days: ["Do"] },
    { start: 60, end: 62, days: ["Vr"] }, { start: 70, end: 76, days: ["Vr"] },
  ];

  /** Beschikbare weekdagen voor een postcode, of null als ophalen niet mogelijk is. */
  function activeDaysForZip(zip, country) {
    if (!zip) return null;
    var digits = (zip + "").replace(/\D/g, "");
    var cfg, num;
    if (country === "BE") { cfg = PPC_BE; num = parseInt(digits.slice(0, 2), 10); }
    else { cfg = PPC_NL; num = parseInt(digits.slice(0, 4), 10); }
    if (!num) return null;
    var matches = cfg.filter(function (c) { return num >= c.start && num <= c.end; });
    if (!matches.length) return null;
    if (matches.some(function (c) { return c.days.length === 0; })) return null; // uitgesloten gebied
    var days = [];
    matches.forEach(function (c) { c.days.forEach(function (d) { if (days.indexOf(d) < 0) days.push(d); }); });
    return days;
  }

  /**
   * Eerstvolgende geldige ophaaldata (minimaal minLead dagen vooruit).
   * Weekend-regel: een aanvraag op zaterdag/zondag kan de eerstvolgende maandag
   * niet als ophaal-/bezorgdag hebben — in het weekend wordt niets verwerkt of
   * klaargezet. Geldt voor retour én ruil. Buiten het weekend verandert er niets.
   */
  function computePickupDates(zip, country, count, minLead) {
    count = count || 6; minLead = minLead || 2;
    var days = activeDaysForZip(zip, country);
    if (!days || !days.length) return [];
    var vandaag = new Date().getDay(); // 0 = zondag, 6 = zaterdag
    var weekendAanvraag = vandaag === 0 || vandaag === 6;
    var out = [];
    var d = new Date(); d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + minLead);
    for (var i = 0; i < 90 && out.length < count; i++) {
      var short = DAY_SHORT[d.getDay()];
      if (days.indexOf(short) >= 0 && !(weekendAanvraag && d.getDay() === 1)) {
        var yyyy = d.getFullYear();
        var mm = ("0" + (d.getMonth() + 1)).slice(-2);
        var dd = ("0" + d.getDate()).slice(-2);
        out.push({
          value: yyyy + "-" + mm + "-" + dd,
          label: DAG_LANG(d.getDay()) + " " + d.getDate() + " " + MAANDEN[d.getMonth()],
        });
      }
      d.setDate(d.getDate() + 1);
    }
    return out;
  }
  function DAG_LANG(i) {
    return ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"][i];
  }

  function euro(n) {
    return "€ " + (Number(n) || 0).toLocaleString("nl-NL", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return (s == null ? "" : "" + s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  // Subregel onder de titel: bestelde variant + SKU.
  function subLine(it) {
    var parts = [];
    if (it.variant) parts.push(esc(it.variant));
    if (it.sku) parts.push("SKU " + esc(it.sku));
    return parts.join(" · ");
  }
  function show(el) { el.hidden = false; }
  function hide(el) { el.hidden = true; }

  // ── Stap 1: order opzoeken ─────────────────────────────────────────────────
  var identifier = ""; // wat de klant invulde (e-mail of postcode)

  lookupForm.addEventListener("submit", function (e) {
    e.preventDefault();
    var order = lookupForm.querySelector("#rp-order").value.trim();
    identifier = lookupForm.querySelector("#rp-email").value.trim();
    if (!order || !identifier) { setMsg(lookupMsg, "Vul je ordernummer en je e-mailadres of postcode in.", true); return; }

    var isEmail = identifier.indexOf("@") >= 0;
    var payload = { orderName: order };
    if (isEmail) payload.email = identifier; else payload.postcode = identifier;

    lookupBtn.disabled = true;
    setMsg(lookupMsg, "Bezig met opzoeken…", false);
    post("/api/retouren/order-lookup", payload)
      .then(function (res) {
        lookupBtn.disabled = false;
        if (!res.ok || res.data.ok === false) {
          setMsg(lookupMsg, (res.data && res.data.error) || "Wij konden geen order vinden met deze gegevens.", true);
          return;
        }
        setMsg(lookupMsg, "", false);
        renderForm(res.data, order);
      })
      .catch(function () {
        lookupBtn.disabled = false;
        setMsg(lookupMsg, "Er ging iets mis. Probeer het later opnieuw.", true);
      });
  });

  // Read-only order-overzicht (bij verstreken termijn of bestaande aanvraag).
  function orderOverzichtHtml(items) {
    var rows = (items || []).map(function (it) {
      return '<div class="return-portal__overview-item">' +
        (it.image ? '<img class="return-portal__item-img" src="' + esc(it.image) + '" alt="" loading="lazy">' : "") +
        '<span class="return-portal__overview-title">' + esc(it.titel) +
          (subLine(it) ? '<small class="return-portal__item-sub">' + subLine(it) + "</small>" : "") +
        "</span>" +
        '<span class="return-portal__overview-qty">× ' + (it.aantal || 1) + "</span>" +
        "</div>";
    }).join("");
    return '<div class="return-portal__section-title">Je order</div><div class="return-portal__items">' + rows + "</div>";
  }

  // Adres- + datumvelden voor een afgehaalde order die tóch laat ophalen (retour) of bezorgen (ruil).
  // Een afhaalorder heeft geen thuisadres op de order, dus de klant vult dit zelf in. De datumopties
  // worden met dezelfde postcodelogica als de winkelwagen-datepicker berekend zodra de postcode is
  // ingevuld (zie de postcode-listener in wireForm).
  function afhaalAdresHtml(datumAttr, datumLabel) {
    return '<span class="return-portal__pickup return-portal__afhaal" data-afhaal-adres hidden>' +
      '<label>Straat en huisnummer<input type="text" data-adres-straat autocomplete="street-address" placeholder="Bijv. Dorpsstraat 12"></label>' +
      '<div class="return-portal__row">' +
        '<label>Postcode<input type="text" data-adres-postcode autocomplete="postal-code" placeholder="1234 AB"></label>' +
        '<label>Plaats<input type="text" data-adres-plaats autocomplete="address-level2"></label>' +
      "</div>" +
      "<label>" + datumLabel + "<select " + datumAttr + '><option value="">Vul eerst je postcode in</option></select></label>' +
      '<small class="return-portal__afhaal-msg" data-afhaal-msg hidden></small>' +
    "</span>";
  }

  // ── Stap 2 + 3: artikelen + methode ────────────────────────────────────────
  function renderForm(data, orderInput) {
    var returnable = (data.items || []).filter(function (it) { return it.retourneerbaar; });
    var geblokkeerd = (data.items || []).filter(function (it) { return !it.retourneerbaar; });
    var pickupDates = computePickupDates(data.postcode, data.land);
    var kanOphalen = pickupDates.length > 0;

    setIntro("Selecteer hieronder de artikelen die je wilt retourneren of omruilen.");

    // Al een aanvraag voor deze order? Blokkeren, maar wél het overzicht tonen.
    if (data.bestaandeRetour) {
      setIntro("");
      body.innerHTML =
        '<div class="return-portal__notice return-portal__notice--warn">' +
        "Voor deze order is al een retour aangevraagd (retournummer " + esc(data.bestaandeRetour.rma) + "). " +
        "Je kunt geen tweede aanvraag voor dezelfde order indienen.</div>" +
        orderOverzichtHtml(data.items);
      hide(stepLookup); show(stepForm);
      return;
    }

    // Buiten de retourtermijn: order wél tonen, maar geen aanvraag mogelijk.
    if (!data.termijnOk) {
      setIntro("");
      body.innerHTML =
        '<div class="return-portal__notice return-portal__notice--warn">' +
        "Deze order kan niet meer geretourneerd worden omdat de retourtermijn van " + esc(data.termijnDagen) + " dagen is verstreken.</div>" +
        orderOverzichtHtml(data.items);
      hide(stepLookup); show(stepForm);
      return;
    }
    if (!returnable.length) {
      setIntro("");
      body.innerHTML =
        '<div class="return-portal__notice return-portal__notice--warn">' +
        "Er staan geen retourneerbare artikelen op deze order. Vloeren en chemische producten " +
        "(o.a. egaline, primer, lijm, kit, lak, olie) kunnen wij niet retour nemen.</div>";
      hide(stepLookup); show(stepForm);
      return;
    }

    var redenen = (data.redenen || ["Anders"]);
    var html = "";
    html += '<div class="return-portal__section-title">Order ' + esc(data.order.name) + " · " + esc(data.order.klantNaam) + "</div>";

    // Artikelen
    html += '<div class="return-portal__items">';
    returnable.forEach(function (it, i) {
      html +=
        '<div class="return-portal__item" data-item="' + i + '">' +
          '<label class="return-portal__item-head">' +
            '<input type="checkbox" data-item-check>' +
            (it.image
              ? '<span class="return-portal__item-imgwrap"><img class="return-portal__item-img" src="' + esc(it.image) + '" alt="" loading="lazy"><span class="return-portal__item-qty-bubble">' + (it.aantal || 1) + "</span></span>"
              : '<span class="return-portal__item-qty-bubble return-portal__item-qty-bubble--noimg">' + (it.aantal || 1) + "</span>") +
            '<span class="return-portal__item-titlewrap">' +
              '<span class="return-portal__item-title">' + esc(it.titel) + "</span>" +
              (subLine(it) ? '<span class="return-portal__item-sub">' + subLine(it) + "</span>" : "") +
            "</span>" +
          "</label>" +
          '<div class="return-portal__item-body" hidden>' +
            '<div class="return-portal__row">' +
              "<label>Aantal retour" +
                '<input type="number" min="1" max="' + (it.aantal || 1) + '" value="1" inputmode="numeric" data-item-qty data-max="' + (it.aantal || 1) + '">' +
                '<small class="return-portal__qty-warn" data-qty-warn hidden></small>' +
              "</label>" +
              "<label>Reden" +
                '<select data-item-reason>' +
                  redenen.map(function (r) { return '<option value="' + esc(r) + '">' + esc(r) + "</option>"; }).join("") +
                "</select>" +
              "</label>" +
            "</div>" +
            '<label class="return-portal__toel">Toelichting (optioneel)' +
              '<input type="text" data-item-note placeholder="Bijv. verkeerde kleur">' +
            "</label>" +
            '<div class="return-portal__pills" data-keuze-pills>' +
              '<button type="button" class="return-portal__pill is-active" data-keuze-btn="terugbetaling">Terugbetaling</button>' +
              '<button type="button" class="return-portal__pill" data-keuze-btn="ruil">Ruilen</button>' +
            "</div>" +
            // Aantalcontrole — geldt voor zowel terugbetaling als ruil (buiten het ruil-blok).
            '<div class="return-portal__aantal-check" data-aantal-check hidden>' +
              '<p class="return-portal__aantal-check-text" data-aantal-check-text></p>' +
              '<label class="return-portal__aantal-check-ok">' +
                '<input type="checkbox" data-aantal-check-ok> <span data-aantal-check-ok-label>Ja, ik wil bewust maar een deel retourneren</span>' +
              "</label>" +
            "</div>" +
            '<div class="return-portal__ruil" data-ruil-block hidden>' +
              '<input type="text" class="return-portal__ruil-search" data-ruil-search placeholder="Zoek een vervangend artikel…" autocomplete="off">' +
              '<div class="return-portal__ruil-results" data-ruil-results hidden></div>' +
              '<div class="return-portal__ruil-chosen" data-ruil-chosen hidden></div>' +
              '<input type="hidden" data-ruil-json>' +
            "</div>" +
          "</div>" +
          '<input type="hidden" data-item-sku value="' + esc(it.sku) + '">' +
          '<input type="hidden" data-item-titel value="' + esc(it.titel) + '">' +
          '<input type="hidden" data-item-prijs value="' + esc(it.prijs || "0") + '">' +
        "</div>";
    });
    html += "</div>";

    // Niet-retourneerbaar
    if (geblokkeerd.length) {
      html += '<div class="return-portal__blocked"><div class="return-portal__blocked-title">Niet-retourneerbaar</div>';
      geblokkeerd.forEach(function (it) {
        html += '<div class="return-portal__blocked-item">' +
          (it.image ? '<img class="return-portal__item-img" src="' + esc(it.image) + '" alt="" loading="lazy">' : "") +
          '<div class="return-portal__blocked-item-text"><b>' + esc(it.titel) + "</b>" +
          (subLine(it) ? '<small class="return-portal__item-sub">' + subLine(it) + "</small>" : "") +
          '<small>' + esc(it.redenNietRetour || "Kan niet geretourneerd worden.") + "</small></div></div>";
      });
      html += "</div>";
    }

    // Methode — volgt uit hóe de order is ontvangen:
    //  afgehaald → klant kiest: zelf terugbrengen (gratis, dezelfde afhaallocatie) óf laten ophalen (kosten)
    //  post      → zelf per post retour naar ons retouradres (eigen porto)
    //  bezorgd   → laten ophalen (kosten, ophaaldatum kiezen)
    var situatie = data.bezorgsituatie || (data.methode === "zelf" ? "afgehaald" : data.methode === "post" ? "post" : "bezorgd");
    var pickupOpties = pickupDates.map(function (d) { return '<option value="' + d.value + '">' + esc(d.label) + "</option>"; }).join("");
    html += '<div data-methode-block>';
    html += '<div class="return-portal__section-title">Wijze van retourneren</div>';
    html += '<div class="return-portal__methods">';
    if (situatie === "afgehaald") {
      // Afgehaald: klant kiest zelf terugbrengen naar de afhaallocatie (gratis) óf laten ophalen
      // (reguliere verzendkosten). Een afhaalorder heeft geen thuisadres → dat vult de klant zelf in.
      var afhaalAdres = esc(data.inleveradres || "").replace(/\n/g, "<br>");
      html +=
        '<label class="return-portal__method" data-methode-opt="zelf">' +
          '<span class="return-portal__method-title"><input type="radio" name="rp-methode" value="zelf" checked data-methode-radio> Zelf terugbrengen <b>gratis</b></span>' +
          '<span class="return-portal__method-desc">Je hebt deze order afgehaald' + (data.afhaallocatie ? " bij " + esc(data.afhaallocatie) : "") +
          ". Je brengt de artikelen kosteloos terug naar diezelfde afhaallocatie:<br><strong>" + afhaalAdres + "</strong></span>" +
        "</label>";
      html +=
        '<label class="return-portal__method" data-methode-opt="ophalen">' +
          '<span class="return-portal__method-title"><input type="radio" name="rp-methode" value="ophalen" data-methode-radio> Laten ophalen <b>' + euro(data.verzendkosten) + "</b></span>" +
          '<span class="return-portal__method-desc">Wij halen je retour bij je thuis op via onze logistieke partner. Vul hieronder je adres in; de verzendkosten worden verrekend met de terugbetaling.</span>' +
          afhaalAdresHtml("data-pickup-date", "Kies een ophaaldatum") +
        "</label>";
    } else if (situatie === "bezorgd") {
      // Klant kiest: zelf terugbrengen/opsturen (eigen kosten) óf laten ophalen (kosten).
      var adresHtml = esc(data.inleveradres || "").replace(/\n/g, "<br>");
      html +=
        '<label class="return-portal__method" data-methode-opt="zelf">' +
          '<span class="return-portal__method-title"><input type="radio" name="rp-methode" value="zelf" checked data-methode-radio> Zelf terugbrengen of opsturen</span>' +
          '<span class="return-portal__method-desc">Je brengt de artikelen zelf terug of stuurt ze per post, beide op eigen kosten, naar onze retourlocatie:<br><strong>' + adresHtml + "</strong></span>" +
        "</label>";
      html +=
        '<label class="return-portal__method' + (kanOphalen ? "" : " return-portal__method--disabled") + '" data-methode-opt="ophalen">' +
          '<span class="return-portal__method-title"><input type="radio" name="rp-methode" value="ophalen" data-methode-radio' + (kanOphalen ? "" : " disabled") + "> Laten ophalen <b>" + euro(data.ophaalkosten) + "</b></span>" +
          '<span class="return-portal__method-desc">Wij halen je retour bij je op via onze logistieke partner. De ophaalkosten worden verrekend met de terugbetaling.</span>' +
          (kanOphalen
            ? '<span class="return-portal__pickup" data-ophaal-datum-wrap hidden><label>Kies een ophaaldatum<select data-pickup-date>' + pickupOpties + "</select></label></span>"
            : '<span class="return-portal__method-desc">Voor postcode ' + esc(data.postcode) + " kunnen wij geen ophaaldatum bepalen; kies dan zelf terugbrengen of opsturen.</span>") +
        "</label>";
    } else if (situatie === "post") {
      html +=
        '<div class="return-portal__method is-fixed" data-methode="post">' +
          '<span class="return-portal__method-title">Terugsturen per post</span>' +
          '<span class="return-portal__method-desc">Deze order is per post bij je bezorgd. Je stuurt de artikelen zelf per post retour naar ons retouradres:<br><strong>' +
            esc(data.retouradresPost || data.inleveradres || "").replace(/\n/g, "<br>") +
            "</strong><br>De verzendkosten zijn voor je eigen rekening. Vermeld je retournummer duidelijk bij het pakket.</span>" +
        "</div>";
    }
    html += "</div></div>"; // methods + methode-block

    // Ruil-logistiek — getoond zodra minstens één artikel wordt geruild (geen ophaalkosten).
    html += '<div data-ruil-logistiek data-situatie="' + situatie + '" data-verzendkosten="' + (data.verzendkosten || 0) + '" data-gratis-vanaf="' + (data.verzendGratisVanaf || 0) + '" hidden>';
    html += '<div class="return-portal__section-title">Bezorging & omruilen</div>';
    html += '<div class="return-portal__ruil-verschil" data-ruil-verschil></div>';
    if (situatie === "afgehaald") {
      // Afgehaalde order: klant kiest opnieuw afhalen bij de afhaallocatie (gratis) óf laten bezorgen
      // (reguliere verzendkosten, thuisadres + bezorgdatum invullen).
      html += '<div class="return-portal__methods">';
      html +=
        '<label class="return-portal__method" data-ruilmethode-opt="afhalen">' +
          '<span class="return-portal__method-title"><input type="radio" name="rp-ruilmethode" value="afhalen" checked data-ruilmethode-radio> Opnieuw afhalen <b>geen retourkosten</b></span>' +
          '<span class="return-portal__method-desc">Je nieuwe artikel(en) liggen klaar bij' + (data.afhaallocatie ? " " + esc(data.afhaallocatie) : " dezelfde afhaallocatie") +
          ". Neem bij het afhalen het terug te sturen artikel mee en lever het daar in. Je betaalt nu het volledige bedrag van de nieuwe artikelen; de waarde van het ingeruilde artikel wordt teruggestort zodra je retour is verwerkt.</span>" +
        "</label>";
      html +=
        '<label class="return-portal__method" data-ruilmethode-opt="bezorgen">' +
          '<span class="return-portal__method-title"><input type="radio" name="rp-ruilmethode" value="bezorgen" data-ruilmethode-radio> Laten bezorgen <b data-ruil-verzend-label>' + euro(data.verzendkosten) + "</b></span>" +
          '<span class="return-portal__method-desc">Je nieuwe artikel(en) worden thuisbezorgd en het terug te sturen artikel wordt op dat moment opgehaald. Vul hieronder je adres in.</span>' +
          afhaalAdresHtml("data-ruil-datum", "Bezorgdatum nieuw artikel") +
        "</label>";
      html += "</div>";
    } else {
      html += '<div class="return-portal__methods"><div class="return-portal__method is-fixed">';
      html += '<span class="return-portal__method-title">Omruilen bij bezorging <b>geen retourkosten</b></span>';
      html += '<span class="return-portal__method-desc">Je nieuwe artikel(en) worden bezorgd en het terug te sturen artikel wordt op dat moment opgehaald. Je betaalt nu het volledige bedrag van de nieuwe artikelen; de waarde van het ingeruilde artikel wordt teruggestort zodra je retour is verwerkt.</span>';
      if (kanOphalen) {
        html += '<span class="return-portal__pickup"><label>Bezorgdatum nieuw artikel<select data-ruil-datum>' +
          pickupDates.map(function (d) { return '<option value="' + d.value + '">' + esc(d.label) + "</option>"; }).join("") +
          "</select></label></span>";
      } else {
        html += '<span class="return-portal__method-desc">Voor postcode ' + esc(data.postcode) + " kunnen wij geen bezorgdatum bepalen; neem contact met ons op.</span>";
      }
      html += "</div></div>";
    }
    html += "</div>";

    // Contact + indienen (validatie op submit bepaalt of de gekozen route geldig is)
    html += '<div class="return-portal__section-title">Je gegevens</div>';
    html += '<div class="return-portal__row">' +
      '<label>Naam<input type="text" data-klant-naam value="' + esc(data.order.klantNaam || "") + '"></label>' +
      '<label>Telefoon (optioneel)<input type="tel" data-klant-tel></label>' +
      "</div>";
    html += '<label class="return-portal__toel">Opmerking (optioneel)<textarea data-klant-opm rows="2"></textarea></label>';
    html += '<button type="button" class="return-portal__btn return-portal__btn--primary" data-submit>Retour aanvragen</button>';
    html += '<p class="return-portal__msg" data-submit-msg aria-live="polite"></p>';

    body.innerHTML = html;
    hide(stepLookup); show(stepForm);
    wireForm(data, orderInput);
  }

  function wireForm(data, orderInput) {
    body.querySelectorAll("[data-item]").forEach(function (item) {
      var check = item.querySelector("[data-item-check]");
      var inner = item.querySelector(".return-portal__item-body");
      check.addEventListener("change", function () {
        inner.hidden = !check.checked;
        item.classList.toggle("is-selected", check.checked);
        updateLogistiek();
        updateAantalCheck(item);
      });
      // Keuze terugbetaling / ruil (button-pills)
      var ruilBlock = item.querySelector("[data-ruil-block]");
      item.querySelectorAll("[data-keuze-btn]").forEach(function (pill) {
        pill.addEventListener("click", function () {
          item.querySelectorAll("[data-keuze-btn]").forEach(function (p) { p.classList.remove("is-active"); });
          pill.classList.add("is-active");
          var isRuil = pill.getAttribute("data-keuze-btn") === "ruil";
          if (ruilBlock) ruilBlock.hidden = !isRuil;
          updateLogistiek();
          updateAantalCheck(item);
        });
      });
      var search = item.querySelector("[data-ruil-search]");
      if (search) wireRuilSearch(item, search);
      var qty = item.querySelector("[data-item-qty]");
      if (qty) qty.addEventListener("input", function () {
        var max = parseInt(qty.getAttribute("data-max"), 10) || 1;
        var warn = item.querySelector("[data-qty-warn]");
        var val = parseInt(qty.value, 10);
        if (!isNaN(val) && val > max) {
          qty.value = max;
          if (warn) { warn.textContent = "Je kunt maximaal " + max + " retourneren (besteld aantal)."; warn.hidden = false; }
        } else if (!isNaN(val) && val < 1) {
          qty.value = 1;
          if (warn) warn.hidden = true;
        } else if (warn) {
          warn.hidden = true;
        }
        updateVerschil();
        updateAantalCheck(item);
      });
    });

    // Keuze zelf/ophalen (afgehaald + bezorgd): het reveal-blok (datum, of adres+datum bij een
    // afgehaalde order) binnen de gekozen optie tonen.
    var methodeRadios = body.querySelectorAll("[data-methode-radio]");
    if (methodeRadios.length) {
      var syncMethode = function () {
        var gekozen = body.querySelector("[data-methode-radio]:checked");
        var val = gekozen ? gekozen.value : "";
        body.querySelectorAll("[data-methode-opt]").forEach(function (opt) {
          var isSel = opt.getAttribute("data-methode-opt") === val;
          opt.classList.toggle("is-selected", isSel);
          var reveal = opt.querySelector("[data-ophaal-datum-wrap], [data-afhaal-adres]");
          if (reveal) reveal.hidden = !isSel;
        });
      };
      methodeRadios.forEach(function (radio) { radio.addEventListener("change", syncMethode); });
      syncMethode();
    }

    // Keuze opnieuw afhalen / laten bezorgen (alleen bij een afgehaalde order die geruild wordt).
    var ruilMethodeRadios = body.querySelectorAll("[data-ruilmethode-radio]");
    if (ruilMethodeRadios.length) {
      var syncRuilMethode = function () {
        var g = body.querySelector("[data-ruilmethode-radio]:checked");
        var val = g ? g.value : "";
        body.querySelectorAll("[data-ruilmethode-opt]").forEach(function (opt) {
          var isSel = opt.getAttribute("data-ruilmethode-opt") === val;
          opt.classList.toggle("is-selected", isSel);
          var reveal = opt.querySelector("[data-afhaal-adres]");
          if (reveal) reveal.hidden = !isSel;
        });
        updateVerschil();
      };
      ruilMethodeRadios.forEach(function (radio) { radio.addEventListener("change", syncRuilMethode); });
      syncRuilMethode();
    }

    // Afgehaalde order die laat ophalen/bezorgen: datumopties herberekenen zodra de klant de postcode
    // invult (zelfde postcode-/dagenlogica als de winkelwagen-datepicker).
    body.querySelectorAll("[data-afhaal-adres]").forEach(function (wrap) {
      var pc = wrap.querySelector("[data-adres-postcode]");
      var sel = wrap.querySelector("select");
      var amsg = wrap.querySelector("[data-afhaal-msg]");
      if (!pc || !sel) return;
      pc.addEventListener("input", function () {
        var dates = computePickupDates(pc.value.trim(), data.land);
        if (dates.length) {
          sel.innerHTML = dates.map(function (d) { return '<option value="' + d.value + '">' + esc(d.label) + "</option>"; }).join("");
          if (amsg) amsg.hidden = true;
        } else {
          sel.innerHTML = '<option value="">Geen datum beschikbaar</option>';
          if (amsg) {
            var genoeg = pc.value.replace(/\D/g, "").length >= (data.land === "BE" ? 2 : 4);
            if (genoeg) {
              amsg.textContent = "Voor deze postcode kunnen wij geen datum bepalen. Kies dan zelf terugbrengen of neem contact met ons op.";
              amsg.hidden = false;
            } else { amsg.hidden = true; }
          }
        }
      });
    });

    updateLogistiek();
    var submitBtn = body.querySelector("[data-submit]");
    if (submitBtn) submitBtn.addEventListener("click", function () { submitForm(data, orderInput); });
  }

  // Toont de ruil-bezorgsectie (i.p.v. de normale ophaal-/inlever-sectie) zodra
  // minstens één aangevinkt artikel wordt geruild.
  function updateLogistiek() {
    var anyRuil = false;
    body.querySelectorAll("[data-item]").forEach(function (item) {
      var checked = item.querySelector("[data-item-check]").checked;
      var actief = item.querySelector("[data-keuze-btn].is-active");
      if (checked && actief && actief.getAttribute("data-keuze-btn") === "ruil") anyRuil = true;
    });
    var normaal = body.querySelector("[data-methode-block]");
    var ruilLog = body.querySelector("[data-ruil-logistiek]");
    if (normaal) normaal.hidden = anyRuil;
    if (ruilLog) ruilLog.hidden = !anyRuil;
    updateVerschil();
  }

  // Aantalcontrole: waarschuwt als er minder wordt geretourneerd/geruild dan besteld,
  // zodat de klant niet per ongeluk maar 1 van bijv. 23 plinten meeneemt en denkt dat
  // automatisch alles retour gaat. Geldt voor zowel terugbetaling als ruil.
  function updateAantalCheck(item) {
    var box = item.querySelector("[data-aantal-check]");
    if (!box) return;
    var actief = item.querySelector("[data-keuze-btn].is-active");
    var isRuil = actief && actief.getAttribute("data-keuze-btn") === "ruil";
    var qtyEl = item.querySelector("[data-item-qty]");
    var besteld = parseInt(qtyEl.getAttribute("data-max"), 10) || 1;
    var val = Math.max(1, parseInt(qtyEl.value, 10) || 1);
    var ok = item.querySelector("[data-aantal-check-ok]");
    if (besteld > 1 && val < besteld) {
      var werkwoord = isRuil ? "ruilt" : "retourneert";
      var actie = isRuil ? "ruilen" : "terugsturen";
      var txt = item.querySelector("[data-aantal-check-text]");
      if (txt) {
        txt.innerHTML = "Let op: je " + werkwoord + " nu <b>" + val + " van de " + besteld + "</b> bestelde stuks. " +
          "Wil je alle " + besteld + " " + actie + "? Pas dan het aantal hierboven aan.";
      }
      var lbl = item.querySelector("[data-aantal-check-ok-label]");
      if (lbl) lbl.textContent = isRuil ? "Ja, ik wil bewust maar een deel ruilen" : "Ja, ik wil bewust maar een deel retourneren";
      box.hidden = false;
    } else {
      box.hidden = true;
      if (ok) ok.checked = false;
    }
  }

  // Toont wat de klant nu betaalt (volle prijs nieuw artikel) en wat later wordt
  // teruggestort (waarde ingeruild artikel), vóór het indienen.
  function updateVerschil() {
    var box = body.querySelector("[data-ruil-verschil]");
    if (!box) return;
    var nieuw = 0, oud = 0, count = 0;
    body.querySelectorAll("[data-item]").forEach(function (item) {
      if (!item.querySelector("[data-item-check]").checked) return;
      var actief = item.querySelector("[data-keuze-btn].is-active");
      if (!actief || actief.getAttribute("data-keuze-btn") !== "ruil") return;
      var json = item.querySelector("[data-ruil-json]").value;
      if (!json) return;
      var ruil; try { ruil = JSON.parse(json); } catch (e) { return; }
      var oudPrijs = parseFloat(item.querySelector("[data-item-prijs]").value) || 0;
      var oudAantal = Math.max(1, parseInt(item.querySelector("[data-item-qty]").value, 10) || 1);
      // Aantal nieuw en aantal retour zijn losgekoppeld: klant kan bijv. 10 terugsturen en 5 nieuwe ontvangen.
      nieuw += (parseFloat(ruil.prijs) || 0) * (ruil.aantal || 1);
      oud += oudPrijs * oudAantal;
      count++;
    });
    var fmt = function (n) { return "€ " + n.toLocaleString("nl-NL", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
    // Verzendtarief + gratis-drempel van de order (backend levert de juiste tier: standaard of pakket).
    var log = body.querySelector("[data-ruil-logistiek]");
    var lbl = body.querySelector("[data-ruil-verzend-label]");
    var tarief = log ? parseFloat(log.getAttribute("data-verzendkosten")) || 0 : 0;
    var gratisVanaf = log ? parseFloat(log.getAttribute("data-gratis-vanaf")) || 0 : 0;

    if (!count) { box.innerHTML = ""; if (lbl) lbl.textContent = fmt(tarief); return; }

    // Verzendkosten van de ruil zijn dynamisch: gratis als de nieuwe artikelen samen boven de drempel
    // uitkomen, anders het reguliere tarief. Zo tonen we het echte bedrag i.p.v. "berekend bij afrekenen".
    var verzend = (gratisVanaf && nieuw >= gratisVanaf) ? 0 : tarief;
    if (lbl) lbl.textContent = verzend > 0 ? fmt(verzend) : "gratis";

    var gekozenRuil = (body.querySelector("[data-ruilmethode-radio]:checked") || {}).value || "";
    var verzendZin;
    if (gekozenRuil === "afhalen") {
      verzendZin = "Je haalt de nieuwe artikel(en) zelf op, dus je betaalt geen verzendkosten.";
    } else if (verzend > 0) {
      verzendZin = "Daar komt " + fmt(verzend) + " verzendkosten bij.";
    } else {
      verzendZin = "De verzending is gratis, omdat je nieuwe artikel(en) samen boven " + fmt(gratisVanaf) + " uitkomen.";
    }
    box.innerHTML =
      '<div class="return-portal__verschil-box">' +
        "Je betaalt nu het <strong>volledige bedrag van het nieuwe artikel</strong> (" + fmt(nieuw) + "). " + verzendZin + " " +
        "De waarde van je ingeruilde artikel (<strong>" + fmt(oud) + "</strong>) wordt teruggestort zodra je retour is verwerkt." +
      "</div>";
  }

  var ruilTimer;
  function wireRuilSearch(item, input) {
    var results = item.querySelector("[data-ruil-results]");
    input.addEventListener("input", function () {
      var q = input.value.trim();
      clearTimeout(ruilTimer);
      if (q.length < 2) { results.hidden = true; results.innerHTML = ""; return; }
      ruilTimer = setTimeout(function () {
        zoekProducten(q).then(function (producten) {
          if (!producten.length) {
            results.innerHTML = '<div class="return-portal__ruil-empty">Geen producten gevonden.</div>';
            results.hidden = false; return;
          }
          results.innerHTML = producten.map(function (p, idx) {
            var img = ruilAfbeelding(p);
            return '<button type="button" class="return-portal__ruil-result" data-pick="' + idx + '">' +
              (img ? '<img src="' + esc(img) + '" alt="">' : '<span class="return-portal__ruil-noimg"></span>') +
              '<span class="return-portal__ruil-result-title">' + esc(p.title) + "</span>" +
              '<span class="return-portal__ruil-result-price">' + esc(p.price || "") + "</span>" +
            "</button>";
          }).join("");
          results.hidden = false;
          results.querySelectorAll("[data-pick]").forEach(function (btn) {
            btn.addEventListener("click", function () {
              selectRuil(item, producten[parseInt(btn.getAttribute("data-pick"), 10)]);
              results.hidden = true; input.value = "";
            });
          });
        });
      }, 300);
    });
  }

  function imgUrl(x) {
    if (!x) return "";
    if (typeof x === "string") return x;
    return x.src || x.url || "";
  }
  // Volledige productdata (incl. varianten) ophalen — suggest.json levert die niet.
  function haalVarianten(handle) {
    if (!handle) return Promise.resolve(null);
    return fetch("/products/" + encodeURIComponent(handle) + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function selectRuil(item, product) {
    var chosen = item.querySelector("[data-ruil-chosen]");
    var jsonInput = item.querySelector("[data-ruil-json]");
    var handle = product.handle || (product.url ? (product.url.split("?")[0].split("/products/")[1] || "") : "");

    chosen.hidden = false;
    chosen.innerHTML = '<div class="return-portal__ruil-loading">Varianten laden…</div>';

    haalVarianten(handle).then(function (vol) {
      var titel = (vol && vol.title) || product.title;
      var productId = (vol && vol.id) || product.id;
      var hoofdImg = imgUrl(vol && vol.featured_image) || ruilAfbeelding(product);
      var variants = (vol && vol.variants) || [];

      function store(v) {
        var vTitle = v && v.title && v.title !== "Default Title" ? v.title : undefined;
        var ruil = {
          variantId: v ? v.id : undefined,
          productId: productId,
          titel: titel,
          sku: v ? v.sku : undefined,
          variant: vTitle,
          prijs: prijsNaarEuro(v ? v.price : product.price),
          image: imgUrl(v && v.featured_image) || hoofdImg,
          handle: handle || product.handle,
          aantal: Math.max(1, parseInt(item.querySelector("[data-item-qty]").value, 10) || 1),
        };
        jsonInput.value = JSON.stringify(ruil);
        chosen.innerHTML =
          '<div class="return-portal__ruil-chosen-card">' +
            (ruil.image ? '<img src="' + esc(ruil.image) + '" alt="">' : '<span class="return-portal__ruil-noimg"></span>') +
            '<div class="return-portal__ruil-chosen-info">' +
              '<span class="return-portal__ruil-chosen-name">' + esc(ruil.titel) + "</span>" +
              (ruil.variant ? '<span class="return-portal__ruil-chosen-var">' + esc(ruil.variant) + "</span>" : "") +
              '<label class="return-portal__ruil-qty">Aantal nieuw<input type="number" min="1" value="' + ruil.aantal + '" inputmode="numeric" data-ruil-aantal></label>' +
            "</div>" +
            '<button type="button" class="return-portal__ruil-clear" data-ruil-clear aria-label="Verwijderen">&times;</button>' +
          "</div>";
        var ruilQty = chosen.querySelector("[data-ruil-aantal]");
        ruilQty.addEventListener("input", function () {
          ruil.aantal = Math.max(1, parseInt(ruilQty.value, 10) || 1);
          jsonInput.value = JSON.stringify(ruil);
          updateVerschil();
        });
        chosen.querySelector("[data-ruil-clear]").addEventListener("click", function () {
          jsonInput.value = ""; chosen.hidden = true; chosen.innerHTML = "";
          updateVerschil();
        });
        updateVerschil();
      }

      if (variants.length > 1) {
        chosen.innerHTML =
          '<div class="return-portal__ruil-variant">' +
            '<div class="return-portal__ruil-chosen-head">' +
              (hoofdImg ? '<img src="' + esc(hoofdImg) + '" alt="">' : "") +
              '<span class="return-portal__ruil-chosen-name">' + esc(titel) + "</span>" +
            "</div>" +
            '<label class="return-portal__ruil-varlabel">Kies een variant' +
              '<select data-ruil-variant>' +
                variants.map(function (v, i) { return '<option value="' + i + '">' + esc(v.title) + (v.available === false ? " (uitverkocht)" : "") + "</option>"; }).join("") +
              "</select>" +
            "</label>" +
            '<button type="button" class="return-portal__btn-mini" data-ruil-confirm>Kies deze variant</button>' +
          "</div>";
        chosen.querySelector("[data-ruil-confirm]").addEventListener("click", function () {
          var i = parseInt(chosen.querySelector("[data-ruil-variant]").value, 10) || 0;
          store(variants[i]);
        });
      } else {
        store(variants[0] || null);
      }
    });
  }

  function zoekProducten(q) {
    var url = "/search/suggest.json?q=" + encodeURIComponent(q) +
      "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last";
    return fetch(url, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d.resources && d.resources.results && d.resources.results.products) || []; })
      .catch(function () { return []; });
  }
  function ruilAfbeelding(p) {
    if (!p) return "";
    if (typeof p.image === "string") return p.image;
    if (p.featured_image && p.featured_image.url) return p.featured_image.url;
    if (p.image && p.image.url) return p.image.url;
    return "";
  }
  function prijsNaarEuro(v) {
    if (typeof v === "number") return (v / 100).toFixed(2);        // cents
    var s = ("" + (v || "")).replace(/[^0-9.,]/g, "").replace(/\.(?=\d{3}\b)/g, "").replace(",", ".");
    var n = parseFloat(s);
    return isFinite(n) ? n.toFixed(2) : "0";
  }

  // Bepaalt de gekozen retourmethode: bij afgehaalde orders mag de klant kiezen
  // (radio), anders volgt de methode vast uit de order (post of ophalen).
  function gekozenMethode(data) {
    var situatie = data.bezorgsituatie || (data.methode === "zelf" ? "afgehaald" : data.methode === "post" ? "post" : "bezorgd");
    if (situatie === "bezorgd" || situatie === "afgehaald") {
      var r = body.querySelector("[data-methode-radio]:checked");
      return r ? r.value : "zelf";
    }
    if (situatie === "post") return "post";
    return "ophalen";
  }

  // Ruil-keuze bij een afgehaalde order: opnieuw afhalen (default) of laten bezorgen. Bij bezorgde
  // orders bestaan deze radio's niet en is een ruil altijd bezorgen.
  function gekozenRuilMethode() {
    var g = body.querySelector("[data-ruilmethode-radio]:checked");
    return g ? g.value : "bezorgen";
  }

  function submitForm(data, orderInput) {
    var msg = body.querySelector("[data-submit-msg]");
    var items = [];
    var anyRuil = false;
    var ruilOntbreekt = false;
    var aantalOnbevestigd = false;
    body.querySelectorAll("[data-item]").forEach(function (item) {
      if (!item.querySelector("[data-item-check]").checked) return;
      var actief = item.querySelector("[data-keuze-btn].is-active");
      var isRuil = actief && actief.getAttribute("data-keuze-btn") === "ruil";
      var ruil;
      if (isRuil) {
        anyRuil = true;
        var json = item.querySelector("[data-ruil-json]").value;
        if (json) { try { ruil = JSON.parse(json); } catch (e) { ruil = null; } }
        if (!ruil) ruilOntbreekt = true;
      }
      // Aantalcontrole (terugbetaling én ruil): minder dan besteld mag alleen bewust bevestigd.
      var qEl = item.querySelector("[data-item-qty]");
      var besteld = parseInt(qEl.getAttribute("data-max"), 10) || 1;
      var gekozenAantal = Math.max(1, parseInt(qEl.value, 10) || 1);
      var ackEl = item.querySelector("[data-aantal-check-ok]");
      if (besteld > 1 && gekozenAantal < besteld && !(ackEl && ackEl.checked)) aantalOnbevestigd = true;
      var aantal = Math.max(1, parseInt(item.querySelector("[data-item-qty]").value, 10) || 1);
      // ruil.aantal (aantal nieuw) staat los van 'aantal' (aantal retour) — niet overschrijven.
      items.push({
        sku: item.querySelector("[data-item-sku]").value,
        aantal: aantal,
        reden: item.querySelector("[data-item-reason]").value,
        toelichting: item.querySelector("[data-item-note]").value.trim() || undefined,
        keuze: isRuil ? "ruil" : "terugbetaling",
        ruil: ruil || undefined,
      });
    });
    if (!items.length) { setMsg(msg, "Selecteer minimaal één artikel.", true); return; }
    if (ruilOntbreekt) { setMsg(msg, "Kies bij een ruil een vervangend artikel.", true); return; }
    if (aantalOnbevestigd) { setMsg(msg, "Controleer het aantal. Van sommige artikelen heb je niet alle bestelde stuks geselecteerd. Pas het aantal aan, of vink aan dat je bewust maar een deel retourneert of ruilt.", true); return; }

    var situatie = data.bezorgsituatie || (data.methode === "zelf" ? "afgehaald" : data.methode === "post" ? "post" : "bezorgd");
    var methode = gekozenMethode(data);
    var ruilMethode = anyRuil ? gekozenRuilMethode() : undefined;
    var ophaaldatum, ruilBezorgdatum, adres;

    // Adres uitlezen uit het opgegeven blok (retour-methode of ruil-logistiek).
    var leesAdres = function (scope) {
      if (!scope) return null;
      var st = scope.querySelector("[data-adres-straat]");
      var pc = scope.querySelector("[data-adres-postcode]");
      var pl = scope.querySelector("[data-adres-plaats]");
      return {
        address1: st ? st.value.trim() : "",
        zip: pc ? pc.value.trim() : "",
        city: pl ? pl.value.trim() : "",
        land: data.land || "NL",
      };
    };
    var adresCompleet = function (a) { return !!(a && a.address1 && a.zip && a.city); };

    if (anyRuil) {
      if (ruilMethode === "bezorgen") {
        if (situatie === "afgehaald") {
          adres = leesAdres(body.querySelector("[data-ruil-logistiek] [data-afhaal-adres]"));
          if (!adresCompleet(adres)) { setMsg(msg, "Vul je adres (straat, postcode en plaats) in voor de bezorging.", true); return; }
        }
        var rd = body.querySelector("[data-ruil-logistiek] [data-ruil-datum]") || body.querySelector("[data-ruil-datum]");
        ruilBezorgdatum = rd ? rd.value : "";
        if (!ruilBezorgdatum) { setMsg(msg, "Kies een bezorgdatum voor het nieuwe artikel.", true); return; }
      }
      // ruilMethode === "afhalen": geen datum of adres nodig.
    } else if (methode === "ophalen") {
      if (situatie === "afgehaald") {
        adres = leesAdres(body.querySelector("[data-methode-block] [data-afhaal-adres]"));
        if (!adresCompleet(adres)) { setMsg(msg, "Vul je adres (straat, postcode en plaats) in voor het ophalen.", true); return; }
      }
      var sel = body.querySelector("[data-methode-block] [data-pickup-date]") || body.querySelector("[data-pickup-date]");
      ophaaldatum = sel ? sel.value : "";
      if (!ophaaldatum) { setMsg(msg, "Kies een ophaaldatum.", true); return; }
    }

    var isEmail = identifier.indexOf("@") >= 0;
    var payload = {
      orderName: orderInput,
      items: items,
      methode: methode,
      ruilMethode: ruilMethode,
      ophaaldatum: ophaaldatum,
      ruilBezorgdatum: ruilBezorgdatum,
      adres: adres || undefined,
      klantNaam: body.querySelector("[data-klant-naam]").value.trim(),
      klantTelefoon: body.querySelector("[data-klant-tel]").value.trim() || undefined,
      klantOpmerking: body.querySelector("[data-klant-opm]").value.trim() || undefined,
    };
    if (isEmail) payload.email = identifier; else payload.postcode = identifier;

    var btn = body.querySelector("[data-submit]");
    btn.disabled = true;
    setMsg(msg, "Bezig met verzenden…", false);
    post("/api/retouren/intake", payload)
      .then(function (res) {
        btn.disabled = false;
        if (!res.ok || res.data.ok === false) {
          setMsg(msg, (res.data && res.data.error) || "Aanvraag mislukt. Probeer het opnieuw.", true);
          return;
        }
        // Ruil: klant rekent het verschil direct af in de Shopify-checkout.
        if (res.data.checkoutPad) {
          setMsg(msg, "Je wordt doorgestuurd naar de betaling…", false);
          window.location.href = res.data.checkoutPad;
          return;
        }
        setIntro("");
        doneText.textContent =
          "Je retournummer is " + res.data.rma + ". Je ontvangt een bevestiging per e-mail met alle details.";
        hide(stepForm); show(stepDone);
        stepDone.scrollIntoView({ behavior: "smooth", block: "start" });
      })
      .catch(function () {
        btn.disabled = false;
        setMsg(msg, "Er ging iets mis. Probeer het later opnieuw.", true);
      });
  }

  // ── Helpers ────────────────────────────────────────────────────────────────
  function post(path, payload) {
    return fetch(ENDPOINT + path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) { return { ok: r.ok, data: data }; });
    });
  }
  function setMsg(el, text, isError) {
    if (!el) return;
    el.textContent = text || "";
    el.classList.toggle("is-error", !!isError);
  }
})();
